import { objMap, } from "../../lib/util";

// --------------------------------------------------

const sm = 768;
const md = 992;
const lg = 1200;

export const breakpoints = {
	xs: { min: 0, max: sm - 1, },
	sm: { min: sm, max: md - 1, },
	md: { min: md, max: lg - 1, },
	lg: { min: lg, max: 100000, },
};
export const bps = breakpoints;

export const colors = {
	text: "#444",
	nav: "#fff",
	footer: "#ddd",
	bg: "#eee",
};

export const font = {
	size: {
		xs: "14px",
		sm: "15px",
		md: "16px",
		lg: "16px",
	},
}

const gutter = {
	xs: 15,
	sm: 20,
	md: 30,
	lg: 40,
};

export const dimensions = {
	nav: {
		height: "4em",
	},
	footer: {
		height: {
			xs: "50px",
			other: "100px",
		}
	},
	panel: {
		width: {
			xs: "80vw",
			other: "300px",
		}
	},
	gutter: {		
		full: objMap(gutter, (k,v) => v + "px"),
		half: objMap(gutter, (k,v) => (0.5 * v) + "px"),
		tripleHalf: objMap(gutter, (k,v) => (1.5 * v) + "px"),
		fullNum: gutter,
		halfNum: objMap(gutter, (k,v) => 0.5 * v),
		tripleHalfNum: objMap(gutter, (k,v) => 1.5 * v),
	},
};
export const dim = dimensions;


// WEBPACK FOOTER //
// ./src/components/style/vars.js